import React from 'react'
import {Text, Tooltip} from '@chakra-ui/react'

import InvoiceActionCell from './InvoiceActionCell'
import LinkCell from './LinkCell'
import InvoiceStatusLabel from '../InvoiceStatusLabel'
import {toLocalDate} from '../../../../../utils/formatter'

const amountCell = ({getValue}) => (
  <Text textAlign="right"> {getValue().toFormat()} </Text>
)

const dateCell = ({getValue}) =>
  toLocalDate(getValue(), {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  })

const statusCell = ({row, getValue}) => (
  <InvoiceStatusLabel daysPastDue={row.getValue('dpd')} status={getValue()} />
)

const referenceCell = ({getValue}) => (
  <Tooltip label={getValue()}>
    <Text
      data-testid="reference-tooltip"
      whiteSpace="nowrap"
      maxWidth={{base: '150px', md: '180px', lg: '250px'}}
      overflow="hidden"
      textOverflow="ellipsis"
    >
      {getValue()}
    </Text>
  </Tooltip>
)

export const columns = (t, payable) => {
  const details = [
    {
      header: t('invoices.table.header.number'),
      accessorKey: 'number',
      cell: ({getValue, row}) => (
        <LinkCell url={row.getValue('pdfUrl')} text={getValue()} />
      ),
    },
    {
      header: t('invoices.table.header.reference'),
      accessorKey: 'reference',
      cell: referenceCell,
    },
    {
      header: t('invoices.table.header.issueDate'),
      accessorKey: 'issueDate',
      cell: dateCell,
    },
    {
      header: t('invoices.table.header.dueDate'),
      accessorKey: 'dueDate',
      cell: dateCell,
    },
    {
      header: t('invoices.table.header.status'),
      accessorKey: 'status',
      cell: statusCell,
    },
    {
      header: t('invoices.table.header.dpd'),
      accessorKey: 'dpd',
      hidden: true,
    },
    {
      header: (
        <Text textAlign="right">{t('invoices.table.header.totalAmount')}</Text>
      ),
      accessorKey: 'totalAmount',
      cell: amountCell,
    },
    {
      header: (
        <Text textAlign="right">{t('invoices.table.header.dueAmount')}</Text>
      ),
      accessorKey: 'dueAmount',
      cell: amountCell,
    },
    {
      header: '',
      hidden: true,
      accessorKey: 'pdfUrl',
    },
    {
      header: '',
      hidden: true,
      accessorKey: 'informPaymentUrl',
    },
  ]

  if (!payable) {
    return details
  }

  const actions = [
    {
      header: '',
      accessorKey: 'paymentUrl',
      cell: ({row}) => (
        <InvoiceActionCell
          paymentUrl={row.getValue('paymentUrl')}
          informPaymentUrl={row.getValue('informPaymentUrl')}
        />
      ),
    },
  ]

  return [...details, ...actions]
}
